import {createSlice, type PayloadAction} from "@reduxjs/toolkit";

import type {ClientValuationRecord} from "#app/api/clients/buildClientValuationsIndex";
import {clientValuationsApi} from "#app/api/clients/clientValuationsRtk";

export type ClientValuationsState = {
    byClientId: Record<string, ClientValuationRecord>;
    managerId: number | null;
    fetchedAt: number | null;
    preloadStatus: "idle" | "loading" | "ready" | "error";
};

const initialState: ClientValuationsState = {
    byClientId: {},
    managerId: null,
    fetchedAt: null,
    preloadStatus: "idle",
};

const clientValuationsSlice = createSlice({
    name: "clientValuations",
    initialState,
    reducers: {
        setClientValuationsIndex(
            state,
            action: PayloadAction<{
                managerId: number;
                fetchedAt: number;
                byClientId: Record<string, ClientValuationRecord>;
            }>
        ) {
            state.byClientId = action.payload.byClientId;
            state.managerId = action.payload.managerId;
            state.fetchedAt = action.payload.fetchedAt;
            state.preloadStatus = "ready";
        },
        setClientValuationsPreloadStatus(
            state,
            action: PayloadAction<ClientValuationsState["preloadStatus"]>
        ) {
            state.preloadStatus = action.payload;
        },
        clearClientValuations() {
            return initialState;
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(
            clientValuationsApi.endpoints.getManagerTodayValuations.matchPending,
            (state) => {
                state.preloadStatus = "loading";
            }
        );
        builder.addMatcher(
            clientValuationsApi.endpoints.getManagerTodayValuations.matchRejected,
            (state) => {
                state.preloadStatus = "error";
            }
        );
    },
});

export const {
    setClientValuationsIndex,
    setClientValuationsPreloadStatus,
    clearClientValuations,
} = clientValuationsSlice.actions;

export default clientValuationsSlice.reducer;
export const clientValuationsSliceReducer = clientValuationsSlice.reducer;
